module.exports = __webpack_public_path__ + "img/vietnam.830bc84.webp";